var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":function($event){return _vm.logout()}}},[_c('log-out-icon',{staticClass:"header-menuitem-icon",attrs:{"size":"13"}}),_c('span',[_vm._v(_vm._s(_vm.$t('dict.logout')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }